import { Loader2 } from "lucide-react";

/**
 * Chat interface loading indicator
 * Shows a centered spinner during initial data load
 */
export function ChatInterfaceSkeleton() {
  return (
    <div className="flex h-full items-center justify-center">
      <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
    </div>
  );
}
